import { makeStyles } from '@material-ui/core';
import { CartPiece } from 'components/WidgetInflationCart/WidgetInflationCart';
import React from 'react';

interface ApparelCardProps {
    card: CartPiece;
}

const useStyles = makeStyles((theme) => ({
    apparelCard: {
        backgroundColor: '#11999E',
        width: '298px',
        height: '363px',
        flexShrink: 0,
        borderRadius: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },
    svg: {
        width: '66px',
        height: '74px',
        flexShrink: 0,
        fill: theme.colors.white,
    },
    h3: {
        color: theme.colors.white,
        textAlign: 'center',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        margin: '0px auto 18px',
    },
    li: {
        color: theme.colors.white,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '25px' /* 178.571% */,
    },
    svgIcon: {
        textAlign: 'center',
    },
}));

const Apparel = ({ card }: ApparelCardProps) => {
    const classes = useStyles();
    return (
        <div className={classes.apparelCard}>
            <div className={classes.svgIcon}>
                <svg
                    className={classes.svg}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="32"
                    viewBox="0 0 24 32"
                    fill="none"
                    data-card={card.card}
                >
                    <path
                        d="M23.9518 22.8527L22.3137 20.1374L23.9468 17.422C24.0071 17.322 24.0171 17.197 23.9719 17.087C23.9267 16.977 23.8362 16.897 23.7206 16.867L18.761 15.5318V14.3817H20.6152C21.3941 14.3817 22.0222 13.7566 22.0222 12.9815V6.0107C22.0323 2.69032 19.3238 0 15.9923 0H8.02277C4.68622 0 1.9828 2.69032 1.9828 6.0107V12.9815C1.9828 13.7566 2.61092 14.3817 3.38978 14.3817H5.24398V15.5318L0.284377 16.867C0.168803 16.897 0.0783547 16.982 0.0331303 17.087C-0.0120941 17.192 -0.00204409 17.317 0.0582551 17.422L1.69136 20.1374L0.05323 22.8527C-0.00706914 22.9527 -0.0171191 23.0777 0.0281053 23.1877C0.0733296 23.2977 0.163778 23.3777 0.279352 23.4077L1.75166 23.8028V28.9734C1.75166 29.1434 1.86723 29.2934 2.02803 29.3334L11.897 31.9887C11.9523 32.0037 12.0377 32.0037 12.093 31.9887L21.9619 29.3334C22.1277 29.2884 22.2383 29.1434 22.2383 28.9734V23.8078L23.7106 23.4127C23.8262 23.3827 23.9166 23.2977 23.9618 23.1927C24.0071 23.0877 24.0121 22.9577 23.9518 22.8527ZM18.7661 19.6873L20.4343 20.1374L18.7661 20.5874V19.6873ZM23.0473 17.467L21.7006 19.7023L18.7661 18.9122V16.3119L23.0473 17.467ZM20.6253 13.6366H18.7711V12.0814H21.2785V12.9865C21.2785 13.3416 20.9821 13.6366 20.6253 13.6366ZM13.51 0.750088C13.3391 1.42017 12.7311 1.91522 12.0025 1.91522C11.2789 1.91522 10.6709 1.42017 10.5001 0.750088H13.51ZM9.74129 0.750088C9.92219 1.83522 10.8669 2.66531 12.0075 2.66531C13.1482 2.66531 14.0929 1.83522 14.2788 0.750088H15.3441C15.1984 2.00023 14.3492 3.08536 13.1331 3.51041C12.7764 3.63543 12.5402 3.98047 12.5402 4.37051V9.44611C12.5402 9.52112 12.4799 9.58112 12.4045 9.58112H11.6307C11.5553 9.58112 11.495 9.52112 11.495 9.44611V4.35051C11.495 3.97547 11.2588 3.64043 10.9121 3.52041C9.68602 3.10036 8.82676 2.01024 8.68606 0.750088H9.74129ZM7.93232 0.755089C8.08307 2.33527 9.13328 3.70043 10.6558 4.2305C10.7011 4.2455 10.7312 4.2955 10.7312 4.35551V9.44611C10.7312 9.93616 11.1332 10.3312 11.6206 10.3312H12.3945C12.8869 10.3312 13.2839 9.93116 13.2839 9.44611V4.37051C13.2839 4.3005 13.319 4.2355 13.3743 4.22049C14.8918 3.69043 15.932 2.32527 16.0828 0.755089C18.952 0.805094 21.2735 3.14037 21.2735 6.0107V11.3263H18.7661V6.8008C18.7661 6.59577 18.5952 6.42575 18.3892 6.42575C18.1832 6.42575 18.0123 6.59577 18.0123 6.8008V20.7924L12.0075 22.4076L6.00275 20.7924V6.8008C6.00275 6.59577 5.8319 6.42575 5.62588 6.42575C5.41985 6.42575 5.24901 6.59577 5.24901 6.8008V11.3313H2.74157V6.0107C2.73654 3.14537 5.05806 0.805094 7.93232 0.755089ZM5.24901 20.5874L3.58073 20.1374L5.24901 19.6873V20.5874ZM3.38978 13.6366C3.02799 13.6366 2.73654 13.3466 2.73654 12.9865V12.0814H5.24398V13.6366H3.38978ZM5.24901 16.3119V18.9122L2.31445 19.7023L0.967767 17.467L5.24901 16.3119ZM2.31445 20.5774L11.4246 23.0277L10.0729 25.268L0.962743 22.8177L2.31445 20.5774ZM2.51545 24.0078L10.1584 26.0631C10.1885 26.0731 10.2237 26.0781 10.2589 26.0781C10.3895 26.0781 10.5151 26.013 10.5805 25.898L11.6307 24.1528V31.1436L2.51545 28.6934V24.0078ZM21.4996 28.6884L12.3844 31.1386V24.1478L13.4346 25.893C13.505 26.008 13.6256 26.0731 13.7562 26.0731C13.7864 26.0731 13.8215 26.0681 13.8567 26.0581L21.4996 24.0028V28.6884ZM13.9371 25.268L12.5854 23.0277L21.6956 20.5774L23.0473 22.8177L13.9371 25.268Z"
                        fill="white"
                    />
                </svg>
            </div>
            <hr />
            <h3 className={classes.h3}>{card.header}</h3>
            <ul>
                {card.list.map((item) => (
                    <li
                        className={classes.li}
                        key={`${card.card}-${Math.random()}`}
                    >
                        {item.desc}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Apparel;
